import chain from '@ersinfotech/chain';
import _ from 'lodash';
import {loop, Effects} from 'redux-loop';
import {FETCH_SOURCEGROUP, FETCH_SOURCEGROUP_SUCCESS} from './actions';
import {fetchSourceGroup} from './tasks';

export const initialState = {
  toHtml: [
    "澳門日報",
    "華僑報",
    "力報",
    "濠江日報",
    "市民日報",
    "大眾報",
    "新華澳報",
    "澳門時報",
    "澳門早報",
    "正報",
    "訊報",
    "星報",
    "現代澳門日報",
    "新報‧今日澳門",
    "澳門會展經濟報",
    "澳門觀察報",
    "澳門晚報",
    "澳門焦點報",
    "明報",
    "東方日報",
    "太陽報",
    "蘋果日報",
    "星島日報",
    "文匯報",
    "大公報",
    "晴報",
    "陽光時務週刊",
    "South China Morning Post",
    "商智謀略",
    "明報周刊",
    "國度復興報",
    "E週刊",
    "壹週Plus",
    "熱血時報"
  ]
};

export default (state = initialState, action) => {
  if (action.type === FETCH_SOURCEGROUP) {
    return loop(
      state
    ,
      Effects.promise(fetchSourceGroup, action.data)
    );
  };

  if (action.type === FETCH_SOURCEGROUP_SUCCESS) {
    const entities = chain(action.data)
      .thru(_.groupBy, 'mediaType')
      .thru(_.mapValues, (groups) => _.keyBy(groups, 'name'))
      .value();

    const result = chain(action.data)
      .thru(_.groupBy, 'mediaType')
      .thru(_.mapValues, (groups) => _.map(groups, 'name'))
      .value();

    return loop({
      ...state,
      entities,
      byId: _.keyBy(action.data, 'id'),
      ...result,
    },
      Effects.none()
    );
  };

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceGroup/reducer.js
 **/